module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ik4k8"))).then(() => parcelRequire('d0iPb'));